import styled from 'styled-components'


export const Wrapper = styled.div`
  background: lightgray ;
  font-family: sans-serif;
  align-items: center;
  text-align: center;
  padding: 20px;

`;

export const Content = styled.div`
  
    display: grid;
    grid-template-columns: repeat(3, minmax(100px,1fr));
    grid-gap: 5px;
`;

